import { dummyClientSubscriptionEng3265 } from "../../containers/AppPage/ControlPanel/Subscription/QuotaSubscription/DowngradeAlert/dummySubscription";

export const dummyAddonPacksInClients = false;
export const getClientsWithDummyAddonPacks = clients => clients.map(client => ({
    ...client,
    addon_packs: [
        {
            id: 16,
            type: "USER",
            addon_pack_id: 1,
            quantity: 6,
            created_at: "Date",
            updated_at: "Date",
        },
        {
            id: 11,
            type: "WHATSAPP",
            addon_pack_id: 3,
            quantity: 6,
            created_at: "Date",
            updated_at: "Date",
        },
        {
            id: 23,
            type: "EMAIL",
            addon_pack_id: 4,
            quantity: 4,
            created_at: "Date",
            updated_at: "Date",
        },
        {
            id: 31,
            type: "STORAGE",
            addon_pack_id: 5,
            quantity: 2,
            created_at: "Date",
            updated_at: "Date",
        },
    ],
}));

export const getClientsWithDummySubscription = clients => clients.map(client => ({
    ...client,
    subscription: dummyClientSubscriptionEng3265,
}));
